import { createReducer } from '@reduxjs/toolkit';

import { OrganisationManager, Loadable } from 'models';
import { makeThunkFromAPICall } from 'state';

export type OrganisationsState = {
    list: Loadable<OrganisationManager.Organisation[]>;
    selected: Loadable<OrganisationManager.Organisation>;
};

const initialState: OrganisationsState = {
    list: { status: 'idle' },
    selected: { status: 'idle' },
};

export const [getOrganisation, setOrganisation] = makeThunkFromAPICall(
    OrganisationManager.getOrganisationById,
    'organisations/get',
);

export const [getOrganisationList, setOrganisationList] = makeThunkFromAPICall(
    OrganisationManager.listOrganisations,
    'organisations/list',
);

export const organisationsReducer = createReducer(initialState, (builder) => {
    builder.addCase(setOrganisation, (state, action) => {
        return {
            ...state,
            selected: { ...state.selected, ...action.payload.loadable },
        };
    });
    builder.addCase(setOrganisationList, (state, action) => {
        return {
            ...state,
            list: { ...state.list, ...action.payload.loadable },
        };
    });
});

export const organisationsActions = {
    getOrganisationList,
    setOrganisationList,
    getOrganisation,
};

export default organisationsReducer;
